<template>
  <div class="animated fadeIn row">
    <nav class="navbar navbar-light bg-light w-full" style="padding: .5rem 1rem;margin-top: -20px;">
      <a class="navbar-brand" href="#"><b>บทความ 
        <span v-bind:class="'flag-icon flag-icon-us'" v-if="covertoLowerCase(lang)=='en'"></span>
        <span v-bind:class="'flag-icon flag-icon-'+covertoLowerCase(lang)" v-if="covertoLowerCase(lang)!='en'"></span>
        </b></a>
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <router-link :to="{ name: 'ArticleAdd'}"><button class="btn btn-lg btn-primary" type="button"><i class="fas fa-plus"></i>
              เพิ่ม</button></router-link>
        </li>
        <li class="nav-item">
          <button class="btn btn-lg btn-dark mx-1" type="button" @click="changeCategories(null)"><i class="far fa-eraser"></i></button>
        </li>
      </ul>
    </nav>
    <div v-for="valueArticle in data.articles" class="card col-md-12" :key="valueArticle.id">
      <div class="card-body">
        <div class="row bd-example2">
          <div class="col-sm-12 col-lg-4">
            <img v-bind:src="valueArticle.image" @error="imageLoadError" class="d-block w-full">
          </div>          
          <div class="col-sm-12 col-lg-8">
            <div id="spy-example2" data-spy="scroll" data-target="#list-example" data-offset="0">
              <h4 class="text-center">
                <b v-html="valueArticle.title"></b>
              </h4>
              <label v-if="valueArticle.created_at">&nbsp;&nbsp;<b>วันที่สร้าง:</b> {{ valueArticle.created_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
              <label v-if="valueArticle.updated_at">&nbsp;&nbsp;<b>วันที่แก้ไข:</b> {{ valueArticle.updated_at |
                moment('timezone', 'Asia/Bangkok', 'L LT')}}</label>
              <div class="col-sm-12" v-if="valueArticle.description!=''" style="overflow: hidden">
                <p>
                  <span v-html="valueArticle.description"></span>
                </p>
              </div>
              <div class="col-sm-12">
                <b-btn v-for="(category,index) in valueArticle.categories" :key="index" @click="changeCategories(category)"
                  class="mx-1" size="sm" variant="primary"><span v-html="categories[category]"></span></b-btn>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <div class="col-sm-12 col-lg-12 row">
              <div class="col-sm-12 col-lg-4">
                  <div class="col-sm-12 col-lg-12 row">
                    <div class="ml-4" v-for="valueLang of valueArticle.languages" :key="valueLang">
                      <span style="margin-top: 1em;" v-bind:class="'btn-lg flag-icon flag-icon-us'" v-if="covertoLowerCase(valueLang)=='en'"></span>
                      <span style="margin-top: 1em;" v-bind:class="'btn-lg flag-icon flag-icon-'+covertoLowerCase(valueLang)" v-if="covertoLowerCase(valueLang)!='en'"></span>
                    </div>
                  </div>
              </div>
              <div class="col-sm-12 col-lg-8">
                  <div class="row">
                    <div class="col-lg-4 col-sm-4">

                      <a target="_blank" style="text-decoration: none" v-bind:href="site_url.src+'blog/'+valueArticle.slug+'-'+valueArticle.id">
                        <b-btn class="mt-3" variant="outline-primary" block><i class="fas fa-eye"></i> แสดงตัวอย่าง</b-btn>
                      </a>

                      <!--<b-btn @click="$router.push({ name: 'ArticleByID',params: { slug: valueArticle.slug},query: { id: valueArticle.id }})"
                        class="mt-3" variant="outline-primary" block><i class="fas fa-eye"></i> แสดงตัวอย่าง</b-btn>-->

                    </div>
                    <div class="col-lg-4 col-sm-4">
                      <b-btn @click="$router.push({ name: 'ArticleEdit',params: { id: valueArticle.id }})" class="mt-3"
                        variant="outline-primary" block><i class="fas fa-edit"></i> แก้ไข</b-btn>
                    </div>
                    <div class="col-lg-4 col-sm-4">
                      <b-btn @click="alertDeleteArticle(valueArticle.id,valueArticle.title)" class="mt-3" variant="outline-primary"
                        block><i class="fas fa-trash-alt"></i> ลบ</b-btn>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-bind:title="article.alert.title" ref="alert" hide-footer v-model="article.alert.active" @ok="article.alert.active = false">
      <div v-if="article.alert.load==false">
        <div class="row">
          <div class="col-md-12 text-center">
            <span v-html="article.alert.detail"></span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6" v-if="article.alert.open.active">
            <b-btn class="mt-3" variant="outline-primary" block @click="submitDelete"><span v-html="article.alert.open.name"></span></b-btn>
          </div>
          <div class="col-lg-3" v-if="article.alert.open.active==false"></div>
          <div class="col-lg-6" v-if="article.alert.close.active">
            <b-btn class="mt-3" variant="outline-secondary" block @click="closeAlert"><span v-html="article.alert.close.name"></span></b-btn>
          </div>
        </div>
      </div>
      <div v-if="article.alert.load">
        <div class="loader-container-4tiles clearfix">
          <div class="square s9 rounded"></div>
          <div class="square s2 rounded"></div>
          <div class="square s1 rounded"></div>
          <div class="square s6 rounded"></div>
        </div>
      </div>
    </b-modal>
    <div v-if="data.per_page&&data.per_page!=null&&data.per_page>1" class="w-full">
      <b-pagination align="center" :total-rows="data.per_page*data.per_page" v-on:input="getCategories" v-model="data.page"
        :per-page="data.per_page"></b-pagination>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import VueMoment from 'vue-moment'
  import moment from 'moment-timezone'
  Vue.use(VueMoment, {
    moment,
  })
  export default {
    data() {
      return {
        load: 0,
        categories: [],
        site_url:{
          src: localStorage.getItem('z_site_url')
        },
        no_image:{
          src: 'https://d2gvpkbpfjsf4i.cloudfront.net/web-builder/no-image.png'
        },
        article: {
          id: null,
          name: '',
          alert: {
            title: '',
            open: {
              active: false,
              name: ''
            },
            close: {
              active: false,
              name: ''
            },
            image: null,
            action: '',
            detail: '',
            active: false,
            load: false
          }
        },
        category_id: this.$route.query.category_id,
        lang: this.$route.query.lang,
        authorization: 'Bearer '+localStorage.getItem('z_token'),
        data: {
          page: this.$route.query.page,
          per_page: null,
          articles: {}
        }
      }
    },
    mounted() {
      if(this.lang){
        this.lang = this.lang
      }
      this.checkLang()
      this.startLoad(2)
      this.getCategories()
    },
    methods: {
      covertoLowerCase(title){
        if(title&&title!=''){
          return title.toLowerCase()
        }else{
          return title
        }
      },
      checkLang(){
        if(!this.lang){
          this.lang='th'
        }
      },
      checkLoad() {
        this.load = this.load - 1
        if (this.load <= 0) {
          this.load = 0
          this.$Progress.finish()
        }
      },
      startLoad(count) {
        this.load = count
        this.$Progress.start()
      },
      failLoad() {
        this.$Progress.fail()
      },
      closeAlert() {
        this.$refs.alert.hide()
      },
      alertDeleteArticle(articleID, articleName) {
        this.article.id = articleID
        this.article.name = articleName
        this.article.alert.title = 'การลบบทความ'
        this.article.alert.detail = 'คุณต้องการลบบทความ "<b>' + articleName + '</b>" ใช่หรือไม่?'
        this.article.alert.open.active = true
        this.article.alert.close.active = true
        this.article.alert.open.name = 'ยืนยันการลบ'
        this.article.alert.close.name = 'ยกเลิกการลบ'
        this.article.alert.active = true
      },
      submitDelete() {
        this.article.alert.load = true
        this.deleteArticleByID()
      },
      getArticles() {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/articles', {
          params: {
            page: this.data.page,
            per_page: this.data.per_page,
            category_id: this.category_id,
            lang: this.lang
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(function (response) {
          this.lang = response.data.json.lang
          this.checkLoad()
          moment.locale(this.lang)
            this.data.page = parseInt(response.data.json.page)
            this.data.per_page = parseInt(response.data.json.per_page)
            if(this.category_id!=null){
              this.$router.replace({ name: 'ArticleList',query: { category_id: this.category_id,page: this.data.page,lang: this.lang }})
            }else{
              this.$router.replace({ name: 'ArticleList',query: { page: this.data.page,lang: this.lang }})
            }
          this.data.articles = response.data.json.data
        }).catch(function (error) {
          this.failLoad()
          this.article.alert.title = 'การดึงข้อมูลบทความ'
          this.article.alert.detail = 'ไม่สามารถทำการดึงบทความได้!'
          this.article.alert.open.active = false
          this.article.alert.close.name = 'ปิด'
          this.article.alert.active = true
        })
      },
      deleteArticleByID() {
        if (this.article.id && this.article.id != '') {
          this.startLoad(2)
          this.$http.delete(process.env.VUE_APP_API_URL + 'api/v1/articles/' + this.article.id, {
            headers: {
              Authorization: this.authorization
            }
          }).then(function (response) {
            this.checkLoad()
            this.article.alert.load = false
            this.getArticles()
            this.article.alert.detail = 'ทำการลบบทความหมายเลข: ' + response.body.json.article.id + ' เรียบร้อย'
            this.article.alert.open.active = false
            this.article.alert.close.name = 'ปิด'
            this.article.alert.active = true
          }).catch(function (error) {
            this.failLoad()
            this.article.alert.detail = 'ไม่สามารถทำการลบบทความได้!'
            this.article.alert.open.active = false
            this.article.alert.close.name = 'ปิด'
            this.article.alert.active = true
          })
        }
      },
      changeCategories(categoryID) {
        this.startLoad(2)
        if(categoryID!=null){
          this.$router.replace({ name: 'ArticleList',query: { category_id: categoryID }})
        }else{
          this.$router.replace({ name: 'ArticleList'})
        }
        this.category_id = categoryID
        this.data.page = 1
        this.getCategories()
      },
      setCategories(categories) {
        let item;
        for (item in categories) {
          this.categories[categories[item].id] = categories[item].name
        }
      },
      imageLoadError(event){
        event.target.src = this.no_image.src
      },
      getCategories() {
        this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/categories', {
          params: {
            lang: this.lang,
            per_page: 100
          },
          headers: {
            Authorization: this.authorization
          }
        }).then(response => {
          this.setCategories(response.body.json.data)
          this.getArticles()
          this.checkLoad()
        }, response => {
          this.failLoad()
        });
      }
    }
  }

</script>
